import { createGlobalStyle } from 'styled-components'

export const theme = {
  'cores': {
    'navy': '#262A5F',
    'navy700': '#2F3470',
    'navyDeep': '#1A1D45',
    'paper': '#F6F1E7',
    'paperAlt': '#FBF7EF',
    'card': '#FFFFFF',
    'ink': '#262A5F',
    'inkDeep': '#23243A',
    'inkSoft': '#5A5C75',
    'inkFaint': '#8A8CA1',
    'accent': '#D5701B',
    'accentSoft': '#E89A4F',
    'accentTint': '#F6E6D3',
    'statusOk': '#3F7D58',
    'statusOkTint': 'rgba(93, 187, 99, 0.2)',
    'statusOkBg': '#E4EFE6',
    'statusWarn': '#B0741E',
    'statusWarnBg': '#F6E9CF',
    'statusStop': '#B23A33',
    'statusStopTint': 'rgba(225, 87, 87, 0.25)',
    'statusStopBg': '#F4E0DD',
    'white': '#FFFFFF',
    'whiteAlpha70': 'rgba(255, 255, 255, 0.7)',
    'whiteAlpha60': 'rgba(255, 255, 255, 0.6)',
    'whiteAlpha40': 'rgba(255, 255, 255, 0.4)',
    'whiteAlpha20': 'rgba(255, 255, 255, 0.2)',
    'whiteAlpha10': 'rgba(255, 255, 255, 0.1)',
    'line': 'rgba(38, 42, 95, 0.13)',
    'lineStrong': 'rgba(38, 42, 95, 0.24)',
    'border': 'rgba(38, 42, 95, 0.13)'
  },
  'fontes': {
    'serif': '\'Spectral\', Georgia, serif',
    'sans': '\'Archivo\', system-ui, sans-serif'
  },
  'raio': {
    'sm': '9px',
    'md': '13px',
    'lg': '18px',
    'xl': '22px'
  },
  'sombras': {
    'sm': '0 1px 2px rgba(26, 29, 69, 0.05), 0 2px 8px rgba(26, 29, 69, 0.05)',
    'md': '0 6px 22px rgba(26, 29, 69, 0.1), 0 2px 6px rgba(26, 29, 69, 0.06)',
    'lg': '0 22px 60px rgba(26, 29, 69, 0.22)',
    'card': '0 1px 2px rgba(26, 29, 69, 0.05), 0 2px 8px rgba(26, 29, 69, 0.05)',
    'passport': '0 6px 22px rgba(26, 29, 69, 0.1), 0 2px 6px rgba(26, 29, 69, 0.06)'
  },
  'breakpoints': {
    'mobile': '640px'
  },
  'mobile': '@media (max-width: 640px)'
}

export const BooksterGlobalStyle = createGlobalStyle`
  body {
    background: ${theme.cores.paper};
  }

  .bookster-scope {
    background:
      radial-gradient(120% 80% at 50% -10%, ${theme.cores.paperAlt} 0%, ${theme.cores.paper} 60%);
    color: ${theme.cores.inkDeep};
    font-family: ${theme.fontes.sans};
    line-height: 1.45;
    min-height: 100vh;
    -webkit-font-smoothing: antialiased;
  }

  .bookster-scope .serif {
    font-family: ${theme.fontes.serif};
    font-weight: 700;
  }

  .bookster-scope b,
  .bookster-scope strong {
    font-weight: 700;
  }
`
